export default class UserCutawaysSaved {
  public static readonly SET_LIST = "USER_CUTAWAYS_SAVED_SET_LIST";
  public static readonly SET_COUNTER = "USER_CUTAWAYS_SAVED_SET_COUNTER";
  public static readonly SET_STATUS = "USER_CUTAWAYS_SAVED_SET_STATUS";
  public static readonly SET_ERROR = "USER_CUTAWAYS_SAVED_SET_ERROR";
  public static readonly CLEAR = "USER_CUTAWAYS_SAVED_CLEAR";

  public static setList(data: any) {
    return {
      data,
      type: UserCutawaysSaved.SET_LIST,
    };
  }

  public static setCounter(data: any) {
    return {
      data,
      type: UserCutawaysSaved.SET_COUNTER,
    };
  }

  public static setStatus(data: any) {
    return {
      data,
      type: UserCutawaysSaved.SET_STATUS,
    };
  }

  public static setError(data: any) {
    return {
      data,
      type: UserCutawaysSaved.SET_ERROR,
    };
  }

  public static clear() {
    return {
      type: UserCutawaysSaved.CLEAR,
    };
  }
}
